// useVerifyToken — po startu appky:
//  - s tokenem: ověří ho přes GET /api/auth/me a dotáhne usera + osy práv do useAuthStore
//  - bez tokenu: zavolá GET /api/auth/capabilities (anonym) → osy práv (canFill=false)
// Volá se z App.jsx (běží vždy, nezávisle na routě).
import { useEffect } from 'react'
import { useAuthStore } from '../store/useAuthStore'
import { authApi } from '../api/auth'

let verified = false

export function useVerifyToken() {
  const { token, setUser, setCapabilities, logout } = useAuthStore()
  useEffect(() => {
    if (verified) return
    verified = true
    if (token) {
      authApi.me()
        .then(u => setUser(u))
        .catch((err) => {
          // 401/403 (token expiroval, účet mezitím blocked/pending/propadlý) → odhlásit.
          // Jiná chyba (síť) → zkusit znovu při dalším renderu.
          verified = false
          // session_expired už obsloužil api/client.js → useAuthStore.sessionExpired().
          if (err?.error === 'session_expired') return
          if (err?.status === 401 || err?.status === 403) logout()
        })
    } else {
      authApi.capabilities()
        .then(c => setCapabilities(c))
        .catch(() => {})   // anonym bez capabilities → zůstává default
    }
  }, [token])
}
